import PropTypes from "prop-types";
import { createContext, useEffect, useReducer } from "react";
// utils
import axios from "../utils/axios";
import { isValidToken, setSession } from "../utils/jwt";
import { fetchProfileApi, loginWithPasswordApi } from "../api/user";
import { getRolesMePartner } from "src/api/stats";

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  rolesMe: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, rolesMe } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      rolesMe,
    };
  },
  LOGIN: (state, action) => {
    const { user, rolesMe } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      rolesMe,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    rolesMe: null,
  }),
  REGISTER: (state, action) => {
    const { user, rolesMe } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      rolesMe,
    };
  },
};

const reducer = (state, action) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext({
  ...initialState,
  method: "jwt",
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const initialize = async () => {
      try {
        const isToken = {
          accessToken: localStorage.getItem("accessToken"),
          tokenType: localStorage.getItem("tokenType"),
          refreshToken: localStorage.getItem("refreshToken"),
          expiresIn: localStorage.getItem("expiresIn"),
        };
        if (isToken.accessToken && isValidToken(isToken.accessToken)) {
          const { data } = await fetchProfileApi();
          const isRole = await getRolesMePartner();
          setSession(isToken);
          dispatch({
            type: "INITIALIZE",
            payload: {
              isAuthenticated: true,
              user: data,
              rolesMe: isRole.data,
            },
          });
        } else {
          const accessToken = localStorage.getItem("accessToken");
          const refreshToken = localStorage.getItem("refreshToken");
          const payload = {
            accessToken,
            refreshToken,
          };
          const response = await axios.post("/v1/users/token", payload, false);
          if (response) {
            localStorage.setItem("accessToken", response.data.accessToken);
            localStorage.setItem("refreshToken", response.data.refreshToken);
            localStorage.setItem("expiresIn", response.data.expiresIn);
            const { data } = await fetchProfileApi();
            const isRole = await getRolesMePartner();
            setSession(isToken);
            dispatch({
              type: "INITIALIZE",
              payload: {
                isAuthenticated: true,
                user: data,
                rolesMe: isRole.data,
              },
            });
          } else {
            dispatch({
              type: "INITIALIZE",
              payload: {
                isAuthenticated: false,
                user: null,
                rolesMe: null,
              },
            });
          }
        }
      } catch (err) {
        dispatch({
          type: "INITIALIZE",
          payload: {
            isAuthenticated: false,
            user: null,
            rolesMe: null,
          },
        });
      }
    };
    initialize();
  }, []);
  // const login = async (username, password) => {
  //   try {
  //     const response = await loginWithPasswordApi({
  //       username,
  //       password,
  //     });
  //     if (response) {
  //       const { tokenType, accessToken, refreshToken, expiresIn } =
  //         response.data;
  //       const isToken = {
  //         tokenType,
  //         accessToken,
  //         refreshToken,
  //         expiresIn,
  //       };
  //       if (response.data) {
  //         await setSession(isToken);
  //         const { data } = await axios.get(
  //           `${process.env.REACT_APP_HOST}/v1/users/info`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${response.data.accessToken}`,
  //             },
  //           }
  //         );
  //         if (data) {
  //           const { user } = data;
  //           if (user.partnerTypeStr === "Affiliate") {
  //             window.location.href = "/dashboard/affiliate";
  //           }
  //           if (user.partnerTypeStr === "IB") {
  //             window.location.href = "/dashboard/app";
  //           }
  //           if (user.partnerTypeStr === "Both") {
  //             window.location.href = "/dashboard/app";
  //           }
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     window.location.reload();
  //   }
  // };

  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post("/api/account/register", {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user, rolesMe } = response.data;

    localStorage.setItem("accessToken", accessToken);

    dispatch({
      type: "REGISTER",
      payload: {
        user,
        rolesMe,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: "LOGOUT" });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        // login,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
